import axios from '@/libs/api.request';

// 获取contextId接口
export const getVerificationContext = params =>
    axios.request({
        url: '/passport/gencontext',
        data: params,
        method: 'post'
    });
// 获取短信验证码
export const getConsolidate = params =>
    axios.request({
        url: '/passport/sendmsg',
        data: params,
        method: 'post'
    });
// 重新获取短信验证码
export const resendMsg = params =>
    axios.request({
        url: '/passport/resend',
        data: params,
        method: 'post'
    });

// 校验短信验证码
export const handleLogin = params =>
    axios.request({
        url: '/passport/login',
        headers: { 'em-login-source': 'redpacketAssistance' },
        data: params,
        method: 'post'
    });
